/**
 * Menu Item Style Utilities
 *
 * Shared styles for menu items in dropdown menus, context menus, etc.
 * Ensures consistent styling across all menu-like components.
 */

import { ICON_DEFAULT } from './icon-styles';

/**
 * Base menu item layout and behavior
 * Common to all menu item variants
 */
export const MENU_ITEM_BASE =
  'relative flex cursor-default items-center gap-2 rounded-sm px-2 py-1.5 text-body1 outline-hidden select-none';

/**
 * Disabled state for menu items
 */
export const MENU_ITEM_DISABLED =
  'data-[disabled]:pointer-events-none data-[disabled]:opacity-50';

/**
 * Inset padding for menu items with icons
 */
export const MENU_ITEM_INSET = 'data-[inset]:pl-8';

/**
 * Combined base menu item styles
 * Includes base layout, disabled state, and icon handling
 */
export const MENU_ITEM = `${MENU_ITEM_BASE} ${MENU_ITEM_DISABLED} ${ICON_DEFAULT}`;

/**
 * Menu item with focus highlight (default style)
 */
export const MENU_ITEM_FOCUSABLE = `${MENU_ITEM} focus:bg-accent/20 focus:text-accent-foreground`;

/**
 * Checkbox/Radio menu item styles
 * Left padding for indicator, right padding for content
 */
export const MENU_ITEM_CHECKABLE = `${MENU_ITEM} focus:bg-accent focus:text-accent-foreground py-1.5 pr-2 pl-8`;

/**
 * Indicator container for checkbox/radio items
 */
export const MENU_ITEM_INDICATOR =
  'pointer-events-none absolute left-2 flex size-3.5 items-center justify-center';

/**
 * Menu label styles
 */
export const MENU_LABEL = 'px-2 py-1.5 text-label1';

/**
 * Menu separator styles
 */
export const MENU_SEPARATOR = 'bg-border -mx-1 my-1 h-px';

/**
 * Menu shortcut text styles
 */
export const MENU_SHORTCUT =
  'text-muted-foreground ml-auto text-body2 tracking-widest';
